import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { ShoppingCart } from 'lucide-react';

const VENDOR_LABELS = {
  beatport: { label: 'Beatport', tag: 'Electronic 5%' },
  traxsource: { label: 'Traxsource', tag: 'House / Techno' },
  itunes: { label: 'iTunes', tag: 'Apple 4-7%' },
  amazon_music: { label: 'Amazon Music', tag: 'Amazon' },
  bandcamp: { label: 'Bandcamp', tag: 'Artist-friendly' },
};

// Display order: DJ-focused stores first, then mainstream
const VENDOR_ORDER = [
  'beatport',
  'traxsource',
  'bandcamp',
  'itunes',
  'amazon_music',
];

/**
 * Bottom-sheet vendor list for buying a track. Pure presentational.
 */
export default function BuyVendorSheet({ buyLinks = {}, open, onOpenChange }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="bg-card border-t border-border max-h-[80vh]">
        <SheetHeader className="text-left">
          <SheetTitle className="font-display">Where to buy</SheetTitle>
        </SheetHeader>
        <div className="mt-4 grid grid-cols-1 gap-2">
          {Object.entries(buyLinks)
            // Filter out retired vendors. Juno Download is winding down as of
            // early 2026, so we suppress its pill on ALL cards — even legacy
            // ones committed before we removed it from `build_buy_links`.
            .filter(([key]) => key !== 'juno_download')
            .sort(([a], [b]) => {
              const ai = VENDOR_ORDER.indexOf(a);
              const bi = VENDOR_ORDER.indexOf(b);
              return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
            })
            .map(([key, url]) => {
            const meta = VENDOR_LABELS[key] || { label: key, tag: '' };
            return (
              <a
                key={key}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-between gap-3 rounded-xl border border-border bg-background px-4 py-3 hover:border-[hsl(var(--primary))]/50 transition-colors duration-200"
                data-testid={`buy-vendor-${key}`}
              >
                <div>
                  <div className="font-display font-semibold">{meta.label}</div>
                  <div className="text-xs text-muted-foreground">{meta.tag}</div>
                </div>
                <ShoppingCart className="w-4 h-4 text-muted-foreground" />
              </a>
            );
          })}
        </div>
      </SheetContent>
    </Sheet>
  );
}
